import React from "react";
import { CTA } from "./cta";
export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                {/* <a
                  href={callLink}
                  className="btn btn-custom btn-lg page-scroll"
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                >
                  Call Now
                </a>
                <a
                  href={whatsappLink}
                  className="btn btn-custom btn-lg page-scroll"
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                >
                  Whatsapp Us
                </a> */}
                <CTA />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
